import { TrendingUpIcon } from 'lucide-react'

import { Body } from './Body'

import type { Announcement } from '../types'

export const marginReportAnnouncement: Announcement = {
  version: '3.1.0',
  date: '2026-08-19',
  title: 'Margen Vehículo y Comisión de Crédito',
  summary: 'El Reporte de Márgenes separa la utilidad del vehículo de la comisión por el financiamiento.',
  icon: TrendingUpIcon,
  Body,
}
